var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('ErrorBox'),_c('router-view',{attrs:{"pathAfterLogin":_vm.pathAfterLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }